import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useMembershipModalState } from '../../../../../modalContext';

type Result = {
	yes: {
		label: string;
		message: string;
		highlight: string;
	};
	no: {
		label: string;
		message: string;
	};
};

export function useCopy(): Result {
	const [{ useDonationLanguage }] = useMembershipModalState();
	const { translate, localizeDate } = useI18n();

	const suffix = useDonationLanguage ? '_donation' : '';

	const startDate = useMemo(
		() => localizeDate(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000), 'date', 'long'),
		[localizeDate],
	);

	return {
		yes: {
			label: translate(`corgi.co.ppmu.modal.selection_yes_title${suffix}`),
			message: translate('corgi.co.ppmu.modal.selection_yes_message', { startDate }),
			highlight: translate('corgi.co.ppmu.modal.highlight_text'),
		},
		no: {
			label: translate('corgi.co.ppmu.modal.no_title'),
			message: translate(`corgi.co.ppmu.modal.no_description${suffix}`),
		},
	};
}
